import * as R from 'ramda';
import { ValidatorUtils } from './utils';

export const minListLengthValidator = {
    message(field: string, args: any) {
        return `'${ValidatorUtils.prettifyName(field)}' must have at least ${args[0]} entries`;
    },
    validate(value: any, args: any) {
        const min = args[0];
        if (min > 0 && (R.isNil(value) || R.isEmpty(value) || !R.is(Array, value) || value.length < min)) {
            return false;
        }
        return true;
    },
};
